import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { CURRENCIES, Currency } from '../modules/dora/constants/currencies';

interface CurrencySelectorProps {
  value: string;
  onChange: (currencyCode: string) => void;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  helperText?: string;
  error?: boolean;
}

const CurrencySelector: React.FC<CurrencySelectorProps> = ({
  value,
  onChange,
  label = "Currency",
  required = false,
  disabled = false,
  helperText,
  error = false,
}) => {
  // Find the selected currency object
  const selectedCurrency = CURRENCIES.find(c => c.code === value) || null;

  return (
    <Autocomplete
      value={selectedCurrency}
      onChange={(_, newValue: Currency | null) => {
        onChange(newValue?.code || '');
      }}
      options={CURRENCIES}
      getOptionLabel={(option) => `${option.code} - ${option.name}`}
      renderOption={(props, option) => (
        <li {...props} key={option.code}>
          <span style={{ marginRight: 12, fontWeight: 500, minWidth: 40 }}>
            {option.code}
          </span>
          <span style={{ marginRight: 8 }}>{option.symbol}</span>
          {option.name}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required={required}
          helperText={helperText}
          error={error}
          fullWidth
          InputProps={{
            ...params.InputProps,
            startAdornment: selectedCurrency ? (
              <span style={{ marginLeft: 8, marginRight: 8, fontWeight: 500 }}>
                {selectedCurrency.code}
              </span>
            ) : null,
          }}
        />
      )}
      disabled={disabled}
      fullWidth
      isOptionEqualToValue={(option, value) => option.code === value?.code}
    />
  );
};

export default CurrencySelector;